// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"R1-z"};